import _extends from "@babel/runtime/helpers/extends";
import _pt from "prop-types";
import tokens from '@datacamp/waffles-tokens';
import { computeDataAttributes } from '@datacamp/waffles-utils';
import { css } from '@emotion/react';
import React from 'react';
import baseStyle from '../baseStyle';
import { jsx as ___EmotionJSX } from "@emotion/react";
var linkStyle = /*#__PURE__*/css(baseStyle, {
  ':hover': {
    textDecoration: 'underline'
  },
  color: tokens.colors.blueDarkText,
  cursor: 'pointer',
  fontSize: tokens.fontSizes.medium,
  fontWeight: tokens.fontWeights.regular,
  lineHeight: tokens.lineHeights.relaxed,
  textDecoration: 'none'
}, process.env.NODE_ENV === "production" ? "" : ";label:linkStyle;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var InternalLink = function InternalLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataAttributes = _ref.dataAttributes,
      href = _ref.href,
      innerRef = _ref.innerRef,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter;
  var parsedDataAttributes = computeDataAttributes(dataAttributes);
  return ___EmotionJSX("a", _extends({
    className: className,
    css: linkStyle,
    href: href,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    ref: innerRef
  }, parsedDataAttributes), children);
};

InternalLink.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _pt.string.isRequired,
  className: _pt.string,
  dataAttributes: _pt.objectOf(_pt.string),
  href: _pt.string,
  onClick: _pt.func,
  onMouseEnter: _pt.func
} : {};
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return ___EmotionJSX(InternalLink, _extends({}, props, {
    innerRef: ref
  }));
});
Link.propTypes = {
  children: _pt.string.isRequired,
  className: _pt.string,
  dataAttributes: _pt.objectOf(_pt.string),
  href: _pt.string,
  onClick: _pt.func,
  onMouseEnter: _pt.func
};
export default Link;